<template>
  <div id="content">
    <div class="page-title">帮助指南
      <div style="height: 8px"></div>
    </div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">苹果手机推送相关设置
        <div style="height: 8px"></div>
      </div>
      <p class="page-title2">步骤如下（IOS 9.0以下系统不支持）</p>
      <p class="page-title2">相关步骤，是指导用户接收报警及门铃来电通知相关操作（请先使用叮咚登录叮咚账号）</p>
      <p class="page-title2">设置叮咚APP</p>

      <p class="page-title2">1.打开叮咚APP，在我的-APP设置里面找到消息通知。如果通知消息显示已开启，表示可正常使用（如下图3）。</p>
      <img src="./iphone1.png" class="bg"/>

      <img src="./iphone2.png" class="bg"/>
      <img src="./iphone3.png" class="bg"/>

      <p class="page-title2">2.点击消息通知，直接跳转至手机设置界面，找到【通知】，进入通知页面后，点击允许通知</p>
      <img src="./iphone4.png" class="bg"/>
      <img src="./iphone5.png" class="bg"/>
      <img src="./iphone6.png" class="bg"/>
      <p class="page-title2">3.在提醒选项，锁定屏幕、通知中心、横幅全都勾选，横幅风格选择持续。开启声音和标记。显示预览选择解锁时（默认），通知分组选择自动</p>
      <img src="./iphone7.png" class="bg"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;
    font-weight:900;
    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title1 {
    font-family:blod 黑体;
    font-weight:100;

    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;

    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title2 {
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }

  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/nobindmsg/iphone/iphone.vue